import { render, staticRenderFns } from "./item-wrapper.vue?vue&type=template&id=fad65d2e&scoped=true&"
import script from "./item-wrapper.vue?vue&type=script&lang=js&"
export * from "./item-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./item-wrapper.vue?vue&type=style&index=0&id=fad65d2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad65d2e",
  null
  
)

export default component.exports